import { searchPublisherAppsV2 } from "@/lib/data/requests/firm/firm-publisher-apps";
import { queryKeys } from "@/lib/data/static/query-keys";
import { useQuery } from "@tanstack/react-query";

export const searchPublisherAppsQueryOptions = (enabled = true) => ({
  queryKey: [queryKeys.firmPublisherApps, "search"],
  queryFn: () => searchPublisherAppsV2(),
  enabled,
});

export const useSearchPublisherApps = (enabled = true) => {
  return useQuery(searchPublisherAppsQueryOptions(enabled));
};
